module.exports = __webpack_public_path__ + "img/feature_1.9efc554c.png";